import type { AssignmentFormData } from '../../../types/assignmentTypes';
import AudienceFormPreview from '../AudienceFormPreview';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { usePreviewStatus } from '../../hooks/usePreviewStatus';

// TODO: Since we're no longer using these previews for the overview, these form wrapper components can be removed at some point when we have time.

export default function AudienceFormPreviewWrapper() {
  const { id } = useParams();
  const { watch } = useFormContext<AssignmentFormData>();
  const { audience, simpleType, bulkAudienceImportData } = watch();
  const { usesBulkAudienceImport } = bulkAudienceImportData;

  usePreviewStatus();

  return (
    <AudienceFormPreview
      audience={audience}
      isLocked={!!id && simpleType === 'pointInTime'}
      renderStatus
      usesBulkAudienceImport={usesBulkAudienceImport}
      renderCount={simpleType === 'pointInTime'}
      renderAutomationCountPlaceholder={simpleType === 'automated' && audience.length === 0}
    />
  );
}
